import { useLocale } from "@/hooks/useLocale";
import { getLink } from "@/functions/getLink";

export const useLink = () => {
  const locale = useLocale();
  return (key, url_slug = null, params = "") => getLink({ key, locale, url_slug, params });
};
